const PARK_PATH_ALIASES = {
  disneylandparis: 'disneyland-park',
  'disneyland-paris': 'disneyland-park',
  studios: 'walt-disney-studios',
  'disney-adventure-world': 'walt-disney-studios',
};

const PARK_SLUG_ALIASES = {
  ak: 'animal-kingdom',
  alt: 'alton-towers',
  animalKingdom: 'animal-kingdom',
  animal_kingdom: 'animal-kingdom',
  ast: 'parc-asterix',
  asterix: 'parc-asterix',
  bb: 'blizzard-beach',
  bel: 'bellewaerde',
  bgt: 'busch-gardens-tampa',
  blizzardBeach: 'blizzard-beach',
  bob: 'bobbejaanland',
  crw: 'carowinds',
  dca: 'disney-california-adventure',
  disneyCaliforniaAdventure: 'disney-california-adventure',
  disneylandCalifornia: 'disneyland-california',
  disneylandParis: 'disneyland-park',
  dlc: 'disneyland-california',
  dlp: 'disneyland-park',
  eft: 'efteling',
  ene: 'energylandia',
  ep: 'epcot',
  epu: 'epic-universe',
  eur: 'europa-park',
  frl: 'ferrari-land',
  fut: 'futuroscope',
  gar: 'gardaland',
  grl: 'grona-lund',
  gronaLund: 'grona-lund',
  hdp: 'heide-park',
  heidePark: 'heide-park',
  hollywoodStudios: 'hollywood-studios',
  hs: 'hollywood-studios',
  hsp: 'hersheypark',
  hkdl: 'hong-kong-disneyland-park',
  hongKongDisneylandPark: 'hong-kong-disneyland-park',
  ioa: 'islands-of-adventure',
  islandsOfAdventure: 'islands-of-adventure',
  kbf: 'knotts-berry-farm',
  kgi: 'kings-island',
  knb: 'knoebels',
  kny: 'kennywood',
  kingsIsland: 'kings-island',
  lfl: 'legoland-florida',
  lgd: 'legoland-deutschland',
  lrd: 'la-ronde',
  ltw: 'lotte-world',
  lePal: 'le-pal',
  magicKingdom: 'magic-kingdom',
  mir: 'mirabilandia',
  mk: 'magic-kingdom',
  mpg: 'movie-park-germany',
  movieParkGermany: 'movie-park-germany',
  nig: 'nigloland',
  pal: 'le-pal',
  pam: 'parque-de-atracciones-de-madrid',
  parcAsterix: 'parc-asterix',
  parqueDeAtraccionesDeMadrid: 'parque-de-atracciones-de-madrid',
  pdf: 'puy-du-fou',
  pha: 'phantasialand',
  plp: 'plopsaland-de-panne',
  plopsalandDepanne: 'plopsaland-de-panne',
  pta: 'portaventura',
  rul: 'rulantica',
  sdc: 'silver-dollar-city',
  seaWorldOrlando: 'seaworld-orlando',
  seaworldOrlando: 'seaworld-orlando',
  sfq: 'six-flags-qiddiyacity',
  shanghaiDisneyland: 'shanghai-disneyland',
  shdl: 'shanghai-disneyland',
  swo: 'seaworld-orlando',
  tdl: 'tokyo-disneyland',
  tds: 'tokyo-disneysea',
  thorpePark: 'thorpe-park',
  tl: 'typhoon-lagoon',
  tokyoDisneyland: 'tokyo-disneyland',
  tokyoDisneySea: 'tokyo-disneysea',
  tov: 'toverland',
  typhoonLagoon: 'typhoon-lagoon',
  usb: 'universal-studios-beijing',
  universalStudios: 'universal-studios',
  universalStudiosBeijing: 'universal-studios-beijing',
  universalStudiosCalifornia: 'universal-studios-california',
  usc: 'universal-studios-california',
  usf: 'universal-studios',
  uss: 'universal-studios-singapore',
  vcb: 'volcano-bay',
  volcanoBay: 'volcano-bay',
  wbe: 'walibi-belgium',
  walibiBelgium: 'walibi-belgium',
  walibiHolland: 'walibi-holland',
  walibiRhoneAlpes: 'walibi-rhone-alpes',
  wds: 'walt-disney-studios',
  wnl: 'walibi-holland',
  wra: 'walibi-rhone-alpes',
  '58392c29-d79d-49e4-9c35-0100d417d24e': 'rulantica',
  '7340550b-c14d-4def-80bb-acdb51d49a66': 'disneyland-california',
  '75ea578a-adc8-4116-a54d-dccb60765ef9': 'magic-kingdom',
  '832fcd51-ea19-4e77-85c7-75d5843b127c': 'disney-california-adventure',
  '85e3b542-af91-4f8a-8d28-445868a7c8fd': 'europa-park',
  '9e938687-fd99-46f3-986a-1878210378f8': 'parc-asterix',
  'ca888437-ebb4-4d50-aed2-d227f7096968': 'walt-disney-studios',
  'dae968d5-630d-4719-8b06-3d107e944401': 'disneyland-park',
  'f111046c-f6e0-48f4-a1d2-bd9de612b980': 'futuroscope',
};

const NON_PARK_ROUTE_SEGMENTS = new Set([
  '',
  'admin',
  'api',
  'beta',
  'login',
  'profile',
  'signup',
]);

const normalizeKey = (value) => String(value || '').trim();

const aliasFor = (value) => {
  const key = normalizeKey(value);
  if (!key) return '';

  return PARK_SLUG_ALIASES[key]
    || PARK_SLUG_ALIASES[key.toLowerCase()]
    || key;
};

const getRouteSlug = (pathname) => {
  const segments = String(pathname || '')
    .split('/')
    .map((segment) => segment.trim())
    .filter(Boolean);

  const segment = segments.find((item) => !NON_PARK_ROUTE_SEGMENTS.has(item.toLowerCase()));
  if (!segment) return '';

  return PARK_PATH_ALIASES[segment] || segment;
};

export const resolveAttractionNotificationParkSlug = (parkSlug, pathname = '') => {
  const raw = normalizeKey(parkSlug);
  const aliased = aliasFor(raw);
  if (raw && aliased !== raw) return aliased;

  const routeSlug = getRouteSlug(pathname);
  if (routeSlug) return routeSlug;

  return aliased;
};

export const equivalentAttractionNotificationParkSlug = (left, right, pathname = '') => {
  return resolveAttractionNotificationParkSlug(left, pathname) === resolveAttractionNotificationParkSlug(right, pathname);
};
